import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_ATTENDANCE_SCHOOLS = gql`
  query ExportFunderAttendanceSchools($input: ExportArgs!) {
    allFunderAttendanceSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
